import { render, staticRenderFns } from "./LayoutFullContainer.vue?vue&type=template&id=5f070752&"
import script from "./LayoutFullContainer.vue?vue&type=script&lang=js&"
export * from "./LayoutFullContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports